export default __webpack_public_path__ + "media/images/icons/columns-solid-c4284faa8fa127adc3eca49a61fff62d.svg";